import { useState } from "react";
import { Link } from "react-router-dom";
import { SUBDOMAINS } from "../../utils/constants";
import { WebsiteButton } from "../buttons/websiteButton";
import { Icon } from "../icons/icon";

export const WebsiteNavbar = ({ className }: { className?: string }) => {
  const [navOpen, setNavOpen] = useState<boolean>();

  return (
    <>
      <div
        className={`w-full flex items-center justify-between gap-4 ${className}`}
      >
        <div className="text-white max-w-[140px] width-lim:max-w-[163px]">
          <Icon svg={"tc-logo"} width={163} height={28} />
        </div>

        <div className="text-base flex items-center justify-center gap-5">
          <Link
            to={`${SUBDOMAINS.member}auth/sign-in`}
            className="text-white hidden md:flex"
          >
            Sign In
          </Link>

          <WebsiteButton
            text="Get started"
            to={`${SUBDOMAINS.member}auth/sign-up`}
            variation="primary-white"
            className="!px-5 !max-w-fit !py-2 !hidden md:!flex !text-base !text-pry-dark-green-400"
          />

          <button
            type="button"
            className="w-fit"
            onClick={() => {
              setNavOpen(true);
            }}
          >
            <Icon
              svg={"hamburger-icon"}
              width={24}
              height={24}
              className={"md:hidden !text-white"}
            />
          </button>
        </div>
      </div>

      {navOpen ? (
        <div className="absolute md:!hidden flex flex-col gap-8 items-end shadow-md top-0 py-8 px-6 left-0 right-0 bg-white rounded-b-3xl">
          <button
            type="button"
            className="w-fit max-w-fit ml-auto"
            onClick={() => {
              setNavOpen(false);
            }}
          >
            <Icon svg={"close-icon"} width={28} height={28} />
          </button>

          <div className="flex flex-col gap-6 w-full">
            <WebsiteButton
              text="Get started"
              to={`${SUBDOMAINS.member}auth/sign-up`}
              variation="primary"
              className="!px-5 !w-full !py-3 "
            />

            <WebsiteButton
              text="Sign in"
              to={`${SUBDOMAINS.member}auth/sign-in`}
              variation="plain-2"
              className="!px-5 !w-full !py-3 "
            />
          </div>
        </div>
      ) : undefined}
    </>
  );
};
